import { Pipe, PipeTransform } from '@angular/core';
import get from 'lodash/get';
import { IMAGE_SHAPE } from '../constants/products.constants';

export interface IMultiUrlImage {
  id?: number;
  original: string;
  small?: string;
  isVertical?: boolean;
  shape?: IMAGE_SHAPE;
}

@Pipe({
  standalone: false,
  name: 'multiUrlImage',
})
export class MultiUrlImagePipe implements PipeTransform {
  transform(image: IMultiUrlImage, size: 'original' | 'small', fallbackUrl: string): string {
    return get(image, size, fallbackUrl);
  }
}
